export class HomeViewModel {
    private allItems: HTMLCollectionOf<Element>;

    constructor(){
        window.onload = this.setLayoutOfTestimonialsForMosaic.bind(this);
        window.addEventListener("resize", this.resizeAllGridItems.bind(this));
        this.allItems = document.getElementsByClassName("testimony");
    }
    
    setLayoutOfTestimonialsForMosaic(){
        $('.testimonials')
            .removeClass('testimonials')
            .addClass('testimonials-mosaic');
        this.resizeAllGridItems();
    }

    resizeGridItem(item) {
        let grid = document.getElementsByClassName("testimonials-mosaic")[0];
        let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
        let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
        let rowSpan = Math.ceil((item.querySelector('.testimony-card').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
        item.style.gridRowEnd = "span " + rowSpan;
    }

    resizeAllGridItems() {
        this.allItems = document.getElementsByClassName("testimony");
        for (let x = 0; x < this.allItems.length; x++) {
            this.resizeGridItem(this.allItems[x]);
        }
    }

    resizeInstance(instance) {
        const item = instance.elements[0];
        this.resizeGridItem(item);
    }
}